import { SlidersHorizontal } from "lucide-react";
import ButtonWrapper from "../../../views/components/reuseComp/ButtonWrapper";
import React, { useEffect, useMemo, useState } from "react";
import { Breadcrumb, DatePicker, Form, Input, Select } from "antd";
import { IReportsListResponse } from "../../../types/api/reports";
import ReportsTable from "./ReportsTable";
import { useReportsList } from "../../../hooks/api/reports/hooks";
import dayjs from "dayjs";
import {
  useQueryStates,
  parseAsInteger,
  parseAsString,
  parseAsBoolean,
} from "nuqs";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const { RangePicker } = DatePicker;

const ReportsLibraryMainComp: React.FC<{ allowURLStateUpdate?: boolean }> = ({
  allowURLStateUpdate = true,
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const [form] = Form.useForm();

  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };

  const [query, setQuery] = useQueryStates(
    {
      page: parseAsInteger.withDefault(1),
      limit: parseAsInteger.withDefault(20),
      startDate: parseAsString,
      endDate: parseAsString,
      reportNumber: parseAsString,
      status: parseAsBoolean,
    },
    DEFAULT_NUQS_CONFIG
  );

  const hasActiveFilters = Boolean(
    query.startDate ||
    query.endDate ||
    query.reportNumber ||
    query.status !== undefined
  );

  useEffect(() => {
    form.setFieldsValue({
      dateRange:
        query.startDate && query.endDate
          ? [dayjs(query.startDate), dayjs(query.endDate)]
          : undefined,
    });

    if (hasActiveFilters) {
      setShowFilters(true);
    }
  }, [query.startDate, query.endDate, , query.reportNumber]);

  const {
    data,
    refetchWithQuery: refetch,
    isFetching,
  } = useReportsList({
     ...query,
     ...DEFAULT_NUQS_CONFIG,
  });

  const qData = data?.qData ?? { page: 1, limit: 20 };

  const reportList: IReportsListResponse[] = useMemo(
    () => data?.data || [],
    [data]
  );

  const handleReset = () => {
    form.resetFields();

    setQuery({
      page: 1,
      startDate: null,
      endDate: null,
      reportNumber: null,
    });
    refetch({
      page: 1,
      limit: qData.limit,
      startDate: null,
      endDate: null,
      reportNumber: null,

    });

    setShowFilters(false);
  };

  const handleSearch = () => {
    const values = form.getFieldsValue();
    setQuery({
      startDate:
        values.dateRange?.[0] &&
        dayjs(values.dateRange[0]).format("YYYY-MM-DD"),
      endDate:
        values.dateRange?.[1] &&
        dayjs(values.dateRange[1]).format("YYYY-MM-DD"),
      reportNumber: values.reportNumber?.trim() || null,
    });

    refetch({
      ...qData,
      startDate:
        values.dateRange?.[0] &&
        dayjs(values.dateRange[0]).format("YYYY-MM-DD"),
      endDate:
        values.dateRange?.[1] &&
        dayjs(values.dateRange[1]).format("YYYY-MM-DD"),
      reportNumber: values.reportNumber?.trim() || null,
    });

  };

  return (
    <div>
      <div className="mb-6">
        <div className="flex justify-between items-center">
          <h1 className="text-xl sm:text-3xl  sm:mb-2">
            Reports Library
          </h1>

          <div>
            <ButtonWrapper
              icon={<SlidersHorizontal className="size-5" />}
              className="bg-primary text-white"
              iconPosition="end"
              onClick={() => setShowFilters(!showFilters)}
            >
              Filters
            </ButtonWrapper>
          </div>
        </div>

        <div className="mb-4">
          <Breadcrumb
            separator=">"
            items={[
              { title: "Dashboard", href: "/" },
              { title: "Reports Library" },
            ]}
          />
        </div>
      </div>
      <div>
        <div
          className={`
          transition-all duration-500 ease-in-out overflow-hidden
          ${showFilters ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"}
        `}
        >
          <div className="bg-white p-4 rounded-xl mb-5 border mt-2">
            <Form
              layout="vertical"
              form={form}
              onFinish={handleSearch}
              className="grid sm:flex-wrap gap-2 lg:gap-4 lg:grid-cols-4"
            >
              {/* <div>
              <Form.Item name="dateRange" label="Date Range">
                <RangePicker className="!w-full sm:w-[250px]" />
              </Form.Item>
              </div> */}
              <div>
              <Form.Item name="reportNumber" label="Report ID" className="search_input">
                <Input
                  placeholder="Enter report Id, 1007"
                  className="!w-full sm:w-[250px]  !p-0"
                />
              </Form.Item>
              </div>
             {/*  <div>
              <Form.Item name="department" label="Department" className="search_input">
                <Input
                  placeholder="Enter department"
                  className="!w-full sm:w-[250px]  !p-0"
                />
              </Form.Item>
              </div>*/}

          

              {/* Buttons */}
              <div className="flex gap-2 mt-1 sm:flex-col ">
                <ButtonWrapper
                  type="primary"
                  htmlType="submit"
                  className="!py-3 sm:!py-2 !px-2 sm:!px-3"
                >
                  Search
                </ButtonWrapper>
                <ButtonWrapper
                  onClick={handleReset}
                  className="!py-3 sm:!py-2 !px-2 sm:!px-3"
                >
                  Reset
                </ButtonWrapper>
              </div>
            </Form>
          </div>
        </div>
        <ReportsTable
          data={reportList}
          {...{ qData, refetch, DEFAULT_NUQS_CONFIG, loading: isFetching }}
        />
      </div>
    </div>
  );
};

export default ReportsLibraryMainComp;
